import React from 'react'
import { useEffect } from 'react'
import glowingbanner from './../../../../../assets/images/blogs/glowingskin-12-08-2025.jpg';
import { useNavigate } from 'react-router-dom';
import favicon from "./../../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const Glowingskin = () => {

   let navigate = useNavigate()
      useEffect(() => {
           document.title = " From Filters to Facials: Regain Skin Confidence Without Makeup | H-Cura Skin Experts";
           const metaDescription = document.querySelector("meta[name='description']");
           if (metaDescription) {
             metaDescription.setAttribute(
               "content",
               " Discover how advanced skin treatments helped me ditch filters and regain my natural glow. Visit H-Cura Skin Clinic in Bangalore or Chennai to start your skin confidence journey.."
             );
           }
           const metaKeywords = document.querySelector("meta[name='keywords']");
           if (metaKeywords) {
             metaKeywords.setAttribute(
               "content",
               "clear skin tips, glowing skin routine, best skin clinic Bangalore, skin specialist Chennai, H-Cura skincare, dermatologist Jayanagar, Valasaravakkam skin clinic, skincare habits for healthy skin, daily skincare routine India, acne treatment Bangalore, pigmentation treatment Chennai, sunscreen skincare tips, hydration therapy for skin, skin confidence without makeup, natural skin glow remedies, gentle cleanser for face, anti-acne foods, skincare consultation Bangalore, beauty sleep for skin, dermatologist near me"
             );
           }
            // Set canonical link
            const existingCanonical = document.querySelector("link[rel='canonical']");
            if (existingCanonical) {
              existingCanonical.setAttribute("href", "https://www.h-cura.com/glowing-skin-treatment");
            } else {
              const canonicalLink = document.createElement("link");
              canonicalLink.setAttribute("rel", "canonical");
              canonicalLink.setAttribute("href", "https://www.h-cura.com/glowing-skin-treatment");
              document.head.appendChild(canonicalLink);
            }
            // Set favicon
         const existingFavicon = document.querySelector("link[rel='icon']");
         if (existingFavicon) {
           existingFavicon.setAttribute("href", favicon);
         } else {
           const faviconLink = document.createElement("link");
           faviconLink.setAttribute("rel", "icon");
           faviconLink.setAttribute("type", "image/x-icon");
           faviconLink.setAttribute("href", favicon);
           document.head.appendChild(faviconLink);
         }
         }, []);
    
  
    const handleBookAppointment = () => {
      navigate('/bookconsultation'); // Use navigate to redirect to the booking page
    
    };

     const handleDownloadPdf = () => {
  const input = document.querySelector('.dentalblog'); // Use the main container class
  
  html2canvas(input, { 
    scale: 2,
    useCORS: true,
    logging: false 
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    pdf.save('H-Cura_GlowingSkin_Treatment.pdf');
  }).catch(error => {
    console.error('Error generating PDF:', error);
    alert('Failed to generate PDF. Please try again.');
  });
};
  return (
    <>
 <div className="dentalblog">
      <div className="dentalblog-banner">
  <img src={glowingbanner} alt="Dental Care Banner" />
  <div className="dentalblog-banner-overlay">
    <h1>Simple Daily Habits to Maintain Clear Skin:</h1>
    <h2> Your Guide to a Glowing, Confident Look
</h2>
    <button 
      className="dentalblogbook-appointment-btn" 
      onClick={handleBookAppointment}
    >
      Book Appointment
    </button>
  </div>
</div>

        
        <div className="dentalblog-container">
          <div className="dentalblog-intro">
            <p>Imagine stepping out without makeup, feeling confident in your natural skin—even under harsh sunlight or a phone camera filter. Sounds like a dream? It’s completely possible! The secret lies in simple daily skincare habits that protect, heal, and nourish your skin from within.</p>
            <p>At H-Cura Multispeciality Clinic, with locations in Jayanagar, Bangalore, and Gerumgambakkam, Chennai, we care about your skin as much as you do. Let’s dive into practical and science-backed habits to protect your skin.</p>
          </div>
          
          <div className="dentalblog-section">
            <h2>✅ Why is Skin Problems Important?</h2>
            <p>Taking care of your skin early helps prevent acne, wrinkles, sun damage, and infections-keeping it healthy, glowing, and youthful for years. Prevention is easier and more effective than treatment later.</p>
            <p>For residents in Bangalore and Chennai, our dentists at H-Cura Multispeciality Clinic recommend following these daily skin hygiene habits to keep your skin healthy and glowing.</p>
          </div>
          
          <div className="dentalblog-tips">
            <div className="dentalblog-tip-card">
              <h3>1. Cleanse Gently Twice a Day</h3>
              <p>Washing your face morning and night removes dirt, excess oil, and pollutants that clog pores and trigger breakouts or dullness.</p>
              <p className="tip-highlight">✅ Clinic Care Tip: Visit our Valasaravakkam clinic in Chennai to find the best dermatologist-approved cleanser for your skin concerns.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>2. Hydrate Inside and Out</h3>
              <p>Drink plenty of water and use a lightweight moisturizer to keep your skin supple and glowing. Hydrated skin is less prone to irritation and aging.</p>
              <p className="tip-highlight">✅ Skin Tip: Try our customized hydration therapy at H-Cura, available in both Bangalore and Chennai clinics.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>3. Apply Sunscreen Every Day – Even Indoors!</h3>
              <p> UV rays can damage your skin even on cloudy days or through windows. Daily SPF protects against sunburn, dark spots, premature aging, and even skin cancer</p>
              <p className="tip-highlight"> ✅ Glow Tip: Heading out in Jayanagar? Stop by H-Cura for a personalized skin consultation and SPF recommendation suited to your skin type.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>4. Eat Skin-Friendly Foods</h3>
              <p>Your skin reflects what you eat. Choose antioxidant-rich fruits, veggies, omega-3s, and avoid oily, processed foods to reduce acne and boost skin clarity</p>
              <p className="tip-highlight"> ✅ Local Food Tip: Explore healthy cafes near Jayanagar and ask our skin experts about diet plans that nourish your skin.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>5.  Avoid Touching Your Face Constantly</h3>
              <p>Touching your face with unwashed hands spreads bacteria and oils, causing breakouts. Always cleanse after workouts or commuting.</p>
              <p className="tip-highlight"> ✅ Pro Hygiene Tip: H-Cura’s team in Chennai can recommend simple hygiene routines to protect sensitive or acne-prone skin</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>6. Prioritize Beauty Sleep</h3>
              <p>During sleep, your skin repairs itself. Lack of rest leads to dull skin, dark circles, and breakouts. Aim for 7–8 hours of uninterrupted sleep.</p>
              <p className="tip-highlight"> ✅ Pro Tip: Ask our skincare professionals at H-Cura Bangalore how to incorporate night serums into your routine for overnight repair.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>7. Visit Your Dermatologist Regularly</h3>
              <p>Professional skin checkups help detect issues early, whether it’s acne, pigmentation, or dryness. We offer personalized care to suit your skin goals.</p>
              <p> At H-Cura Multispeciality Clinic, with branches in Jayanagar, Bangalore and Valasaravakkam, Chennai, our skin specialists provide science-backed, gentle treatments to keep your skin radiant and healthy</p>
            </div>
          </div>
          
          <div className="dentalblog-cta">
            <h2>📞 Book Your Appointment Now</h2>
            <p>👉 Call: <a href="tel:+918870001377">+91 88700 01377</a></p>
            <p>📍 Visit us in Bangalore (Jayanagar) or Chennai (Tambaram , Gerugambakkam & Valasaravakkam)</p>
          </div>
          
          <div className="dentalblog-summary">
            <h2>🌟 Quick Summary: Your Skin-Loving Checklist</h2>
            <ul>
              <li>✅ Cleanse your face twice daily with a gentle, pH-balanced cleanser</li>
              <li>✅ Use sunscreen daily, even indoors</li>
              <li>✅ Moisturize with skin-type-specific products</li>
              <li>✅ Avoid harsh scrubs and over-washing</li>
              <li>✅ Stay hydrated and eat antioxidant-rich foods</li>
              <li>✅ Schedule regular skin consultations in Bangalore or Chenna</li>
            </ul>
            <p>By practicing these simple daily habits, you're not just preventing breakouts and pigmentation—you're investing in clear, glowing, and healthy skin for life.</p>
          </div>
          
          <div className="dentalblog-testimonials">
            <h2>❤️ Why H-Cura is the Best Choice for Your Skin Health</h2>
            <p>At H-Cura Multispeciality Clinic, our dermatology experts in Jayanagar, Bangalore, and Valasaravakkam, Chennai, provide personalized skincare plans, modern treatments, and ongoing support to help you achieve radiant skin</p>
            <div className="testimonial-container">
              <div className="testimonial">
                <p>💬  “I was struggling with acne for years, but the team at H-Cura in Jayanagar customized a plan that finally worked for me!” – A glowing review from a Bangalore patient</p>
              </div>
              <div className="testimonial">
                <p>💬 “The best skin clinic near me in Chennai! They treated my pigmentation and gave me tips to maintain healthy skin daily.” – A satisfied patient from Valasaravakkam</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Blog as PDF
            </button>
          </div>
    
    
    </>
  )
}

export default Glowingskin